import { Badge } from '../ui/index.js'

type BadgeColor = 'gray' | 'blue' | 'green' | 'red' | 'yellow'

const STATUS_MAP: Record<string, BadgeColor> = {
  // AI generation / general
  PENDING: 'yellow',
  PROCESSING: 'blue',
  COMPLETED: 'green',
  FAILED: 'red',
  // Payment status
  REFUNDED: 'gray',
  // Payment type
  PREMIUM_UPGRADE: 'blue',
  AI_CREDITS: 'green',
  AI_CREDITS_BUNDLE: 'green',
  // User plan
  PREMIUM: 'blue',
  FREE: 'gray',
  // User role
  ADMIN: 'red',
  USER: 'gray',
  // Invitation
  PUBLISHED: 'green',
  DRAFT: 'yellow',
  // Credit transaction
  DEDUCT: 'red',
  REFUND: 'blue',
  PURCHASE: 'green',
  BONUS: 'yellow',
}

interface StatusBadgeProps {
  status: string
  label?: string
  className?: string
}

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const color = STATUS_MAP[status] ?? 'gray'
  return <Badge color={color} className={className}>{label ?? status}</Badge>
}
